<template>
  <button
    v-t="'widget.toLayer'"
    class="widget-footer-button"
    @click="open"
  />
</template>

<script>
import { mapStores } from 'pinia'

export default {
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    open() {
      this.mainStore.openDeeplink(`/me/rewards`)
    },
  },
}
</script>

<style lang="scss" scoped>
.widget-footer-button {
  @apply bg-theme-primary h-12 items-center rounded-b-lg shadow-card text-white w-full;
}
</style>
